// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__4Sgar","svgContainer":"styles_svgContainer__T5u4Y","bg":"styles_bg__ZqqRh","fg":"styles_fg__IGVgt","hide":"styles_hide__cPmoy"};